import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LocaleService } from '@shared/services/locale.service';

@Component({
	selector: 'app-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit, OnDestroy {
	constructor(private title: Title, public locale: LocaleService) {}

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['404']['n17'] + ' | ' + this.locale.translations['header']['n0']);
	}

	ngOnDestroy(): void {}
}
